'use client';
import { useRouter } from '#pplx/frontend/router/provider.js';
import React from 'react';
/**
 * A component that performs a client-side redirect using router.replace().
 * This replaces the current history entry instead of adding a new one,
 * preventing the user from navigating back to the old route.
 *
 * @example
 * ```tsx
 * const RedirectToNewPage: React.FC = () => (
 *   <RedirectTo to="/new-page" />
 * );
 * ```
 */
export const RedirectTo = ({ to }) => {
    const { replace } = useRouter();
    React.useEffect(() => {
        replace(to);
    }, [replace, to]);
    return null;
};
//# sourceMappingURL=redirects.js.map